import axios from '../../axios-config'

export const getTransactionUsageReport = (data) => {
  return axios.post('/score/api/v1/bank/transaction/usage', {
    ...data,
    currencyCode: null
  })
}
